import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/global.css';

// Register WebMCP imperative tools on current entry point (document.modelContext ?? navigator.modelContext)
if (typeof window !== 'undefined') {
  const docAny = document as unknown as {
    modelContext?: { registerTool?: (tool: Record<string, unknown>) => void };
  };
  const navAny = navigator as unknown as {
    modelContext?: { registerTool?: (tool: Record<string, unknown>) => void };
  };
  const mc = docAny.modelContext ?? navAny.modelContext;
  if (mc && typeof mc.registerTool === 'function') {
    mc.registerTool({
      name: 'search_pmcstech_catalog',
      description:
        'Tìm kiếm sản phẩm đầu đọc thẻ UHF RFID Chainway, tem nhãn RFID, máy in RFID Zebra, máy quét mã vạch Opticon, máy kiểm kho PDA và phần mềm ECAMPMCS tại pmcstech.com',
      inputSchema: {
        type: 'object',
        properties: {
          query: {
            type: 'string',
            description: 'Từ khóa thiết bị RFID, mã vạch Opticon/Chainway/Zebra hoặc phần mềm ECAMPMCS'
          }
        },
        required: ['query']
      },
      execute: async (args: { query?: string }) => {
        const q = encodeURIComponent(args?.query || '');
        window.location.href = `/shop/?query=${q}`;
        return { content: [{ type: 'text', text: `Navigating to /shop/?query=${q}` }] };
      }
    });
  }
}

const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}
